"use client";
/* Auto-generated. Do not edit. */
/* Source: src/pages/home-modules/home-seven/sections/footerSection.tsx */

import { SmartImage } from "@/Components";
import { SmartLink } from "@/Components";
import { renderCollectionNode, renderItemNode, renderNode } from "@/Templates/section-node-renderers";
import { FC, ComponentProps, Key, ReactNode } from "react";

type FooterSection336sItem = {
    key: Key | null | undefined;
    /** Detected variants: "col-xl-3 col-lg-3 col-md-6" */
    className?: string;
    footerWidgetItems?: FooterSectionDivsItem[];
};

type FooterSectionDivsItem = {
    key: Key | null | undefined;
    /** Detected variants: "+1 89320 43454, +1 32365 54157" | "info@example.com" */
    pText: ReactNode;
};

type FooterSectionUls2Item = {
    key: Key | null | undefined;
    /** Detected variants: "fa-brands fa-facebook" | "fa-brands fa-x-twitter" | "fa-brands fa-instagram" | "fa-brands fa-linkedin" */
    className: string;
    /** Detected variants: "#" */
    href?: string;
};

type FooterSectionUlsItem = {
    key: Key | null | undefined;
    /** Detected variants: "Home" | "About" | "Contact Us" | "Hospitals" | "Specialities" | "Clinics" */
    link0Text: ReactNode;
    /** Detected variants: "all_routes.home7" | "all_routes.aboutUs" | "all_routes.contactUs" | "all_routes.hospitals" | "all_routes.speciality" | "all_routes.clinics" */
    href: string;
};
export type HomeSevenFooterSectionGeneratedProps = {
    divDiv0Div0Link0LinkProps?: Partial<ComponentProps<typeof SmartLink>> | ((item: FooterSection336sItem) => Partial<ComponentProps<typeof SmartLink>>);
    divDiv0Div0Link0ImageWithBasePath0ImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">> | ((item: FooterSection336sItem) => Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>);
    footerDiv0Div0Div0ClassName?: string;
    /** Default: "© 2025 Doccure" */
    footerDiv2Div0Div0Div0DivText?: ReactNode;
    footerSectionUls2LiLink0LinkProps?: Partial<ComponentProps<typeof SmartLink>> | ((item: FooterSectionUls2Item) => Partial<ComponentProps<typeof SmartLink>>);
    liLink0LinkProps?: Partial<ComponentProps<typeof SmartLink>> | ((item: FooterSectionUlsItem) => Partial<ComponentProps<typeof SmartLink>>);
    footerSection336s: FooterSection336sItem[];
    footerSectionUls2: FooterSectionUls2Item[];
    footerSectionUls: FooterSectionUlsItem[];
    footerSection336sItemWrapper?: (item: FooterSection336sItem, content: ReactNode) => ReactNode;
    footerSection336sRenderer?: (defaultNode: ReactNode) => ReactNode;
    footerSection336sLinkVisible?: boolean;
    footerSection336sLinkRenderer?: (item: FooterSection336sItem, defaultNode: ReactNode) => ReactNode;
    footerSection336sImageVisible?: boolean;
    footerSection336sImageRenderer?: (item: FooterSection336sItem, defaultNode: ReactNode) => ReactNode;
    footerSection336sLinkProps?: Partial<ComponentProps<typeof SmartLink>> | ((item: FooterSection336sItem) => Partial<ComponentProps<typeof SmartLink>>);
    footerSection336sImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">> | ((item: FooterSection336sItem) => Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>);
    footerSectionDivsItemWrapper?: (item: FooterSectionDivsItem, content: ReactNode) => ReactNode;
    footerSectionDivsRenderer?: (defaultNode: ReactNode) => ReactNode;
    footerSectionUls2ItemWrapper?: (item: FooterSectionUls2Item, content: ReactNode) => ReactNode;
    footerSectionUls2Renderer?: (defaultNode: ReactNode) => ReactNode;
    footerSectionUls2LinkVisible?: boolean;
    footerSectionUls2LinkRenderer?: (item: FooterSectionUls2Item, defaultNode: ReactNode) => ReactNode;
    footerSectionUls2LinkProps?: Partial<ComponentProps<typeof SmartLink>> | ((item: FooterSectionUls2Item) => Partial<ComponentProps<typeof SmartLink>>);
    footerSectionUlsItemWrapper?: (item: FooterSectionUlsItem, content: ReactNode) => ReactNode;
    footerSectionUlsRenderer?: (defaultNode: ReactNode) => ReactNode;
    footerSectionUlsLinkVisible?: boolean;
    footerSectionUlsLinkRenderer?: (item: FooterSectionUlsItem, defaultNode: ReactNode) => ReactNode;
    footerSectionUlsLinkProps?: Partial<ComponentProps<typeof SmartLink>> | ((item: FooterSectionUlsItem) => Partial<ComponentProps<typeof SmartLink>>);
};

const HomeSevenFooterSectionGenerated: FC<HomeSevenFooterSectionGeneratedProps> = ({
    footerDiv2Div0Div0Div0DivText = "© 2025 Doccure",
    divDiv0Div0Link0ImageWithBasePath0ImageProps,
    divDiv0Div0Link0LinkProps,
    footerSectionUls2LiLink0LinkProps,
    liLink0LinkProps,
    footerDiv0Div0Div0ClassName,
    footerSection336s,
    footerSectionUls2,
    footerSectionUls,
    footerSection336sItemWrapper,
    footerSection336sRenderer,
    footerSection336sLinkVisible,
    footerSection336sLinkRenderer,
    footerSection336sImageVisible,
    footerSection336sImageRenderer,
    footerSection336sLinkProps,
    footerSection336sImageProps,
    footerSectionDivsItemWrapper,
    footerSectionDivsRenderer,
    footerSectionUls2ItemWrapper,
    footerSectionUls2Renderer,
    footerSectionUls2LinkVisible,
    footerSectionUls2LinkRenderer,
    footerSectionUls2LinkProps,
    footerSectionUlsItemWrapper,
    footerSectionUlsRenderer,
    footerSectionUlsLinkVisible,
    footerSectionUlsLinkRenderer,
    footerSectionUlsLinkProps,
}) => {
    return (
        <footer className="footer-seven">
            <div className="footer-top">
                <div className="container">
                    <div className={footerDiv0Div0Div0ClassName ?? "row g-4"}>
                        {renderCollectionNode(
                            footerSection336s,
                            (item: FooterSection336sItem) => (
                                <div className={item.className ?? "col-xl-3 col-lg-3 col-md-6"} key={item.key}>
                                    <div className="footer-widget footer-about">
                                        <div className="footer-logo">
                                            {renderItemNode(footerSection336sLinkVisible, footerSection336sLinkRenderer, item, (
                                                <SmartLink {...(typeof footerSection336sLinkProps === "function" ? footerSection336sLinkProps(item) : (footerSection336sLinkProps ?? {}))} {...(typeof divDiv0Div0Link0LinkProps === "function" ? divDiv0Div0Link0LinkProps(item) : (divDiv0Div0Link0LinkProps ?? {}))} href="#">
                                                    {renderItemNode(footerSection336sImageVisible, footerSection336sImageRenderer, item, (
                                                        <SmartImage src="/Templates/Doccure/img/logo-07.svg" alt="logo" className="img-fluid" {...(typeof footerSection336sImageProps === "function" ? footerSection336sImageProps(item) : (footerSection336sImageProps ?? {}))} {...(typeof divDiv0Div0Link0ImageWithBasePath0ImageProps === "function" ? divDiv0Div0Link0ImageWithBasePath0ImageProps(item) : (divDiv0Div0Link0ImageWithBasePath0ImageProps ?? {}))} />
                                                    ))}
                                                </SmartLink>
                                            ))}
                                        </div>
                                    </div>
                                </div>
                            ),
                            footerSection336sItemWrapper,
                            footerSection336sRenderer
                        )}
                    </div>
                </div>
            </div>
            <div className="footer-middle">
                <div className="container">
                    <div className="footer-links">
                        <ul className="footer-menu">
                            {renderCollectionNode(
                                footerSectionUls,
                                (item: FooterSectionUlsItem) => (
                                    <li key={item.key}>
                                        {renderItemNode(footerSectionUlsLinkVisible, footerSectionUlsLinkRenderer, item, (
                                            <SmartLink href={item.href} {...(typeof footerSectionUlsLinkProps === "function" ? footerSectionUlsLinkProps(item) : (footerSectionUlsLinkProps ?? {}))} {...(typeof liLink0LinkProps === "function" ? liLink0LinkProps(item) : (liLink0LinkProps ?? {}))}>{item.link0Text}</SmartLink>
                                        ))}
                                    </li>
                                ),
                                footerSectionUlsItemWrapper,
                                footerSectionUlsRenderer
                            )}
                        </ul>
                        <div className="social-icon">
                            <ul>
                                {renderCollectionNode(
                                    footerSectionUls2,
                                    (item: FooterSectionUls2Item) => (
                                        <li key={item.key}>
                                            {renderItemNode(footerSectionUls2LinkVisible, footerSectionUls2LinkRenderer, item, (
                                                <SmartLink href={item.href ?? "#"} {...(typeof footerSectionUls2LinkProps === "function" ? footerSectionUls2LinkProps(item) : (footerSectionUls2LinkProps ?? {}))} {...(typeof footerSectionUls2LiLink0LinkProps === "function" ? footerSectionUls2LiLink0LinkProps(item) : (footerSectionUls2LiLink0LinkProps ?? {}))}>
                                                    <i className={item.className} />
                                                </SmartLink>
                                            ))}
                                        </li>
                                    ),
                                    footerSectionUls2ItemWrapper,
                                    footerSectionUls2Renderer
                                )}
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
            <div className="footer-bottom">
                <div className="container">
                    <div className="copyright">
                        <div className="copyright-text">{footerDiv2Div0Div0Div0DivText}</div>
                    </div>
                </div>
            </div>
        </footer>
    );
};

export default HomeSevenFooterSectionGenerated;
